import { Component, inject } from "@angular/core";
import { Sexe } from "@jack-sparrow-libraries/emotion-models";
import { MatDialogRef } from "@angular/material/dialog";
import { UiKitModule } from "@jack-sparrow-libraries/ui-kit";

export namespace SexeNewCvPatientQuestionComponent {
	export type Output = Sexe | null;
}

@Component({
	selector: "cba-sexe-new-cv-patient-question",
	templateUrl: "./sexe-new-cv-patient-question.component.html",
	styleUrls: ["./sexe-new-cv-patient-question.component.scss"],
	imports: [UiKitModule],
})
export class SexeNewCvPatientQuestionComponent {
	readonly Sexe = Sexe;
	readonly dialogRef: MatDialogRef<SexeNewCvPatientQuestionComponent, SexeNewCvPatientQuestionComponent.Output> =
		inject(MatDialogRef);
}
